export default {
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/components/resources/methods.js